var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OverviewCard',{attrs:{"item":_vm.item},on:{"click":_vm.showContentTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }